import { User, Shield, Briefcase, Calculator, Headphones } from 'lucide-react';

const roleConfigs = [
  { role: 'all', label: 'All Users', icon: User, color: 'bg-slate-100 text-slate-600' },
  { role: 'customer', label: 'Customers', icon: User, color: 'bg-green-100 text-green-600' },
  { role: 'provider', label: 'Providers', icon: Briefcase, color: 'bg-blue-100 text-blue-600' },
  { role: 'manager', label: 'Managers', icon: Shield, color: 'bg-indigo-100 text-indigo-600' },
  { role: 'customer_service', label: 'Customer Service', icon: Headphones, color: 'bg-teal-100 text-teal-600' },
  { role: 'accountant', label: 'Accountants', icon: Calculator, color: 'bg-emerald-100 text-emerald-600' },
  { role: 'admin', label: 'Admins', icon: Shield, color: 'bg-purple-100 text-purple-600' },
];

export default function UserStatsCards({ stats, roleFilter, onFilterChange }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      {roleConfigs.map((item) => (
        <button
          key={item.role}
          onClick={() => onFilterChange(item.role)}
          className={`p-4 rounded-xl border-2 transition-all ${
            roleFilter === item.role 
              ? 'border-amber-500 bg-amber-50' 
              : 'border-stone-200 bg-white hover:border-stone-300'
          }`}
          data-testid={`filter-${item.role}`}
        >
          <div className={`w-10 h-10 rounded-xl ${item.color} flex items-center justify-center mb-3`}>
            <item.icon className="w-5 h-5" />
          </div>
          <p className="text-2xl font-bold text-slate-900">{stats[item.role] || 0}</p>
          <p className="text-sm text-slate-500">{item.label}</p>
        </button>
      ))}
    </div>
  );
}
